import * as React from 'react';

import {QuillToolbar} from 'shells/rich-textarea/quill-toolbar';

type Props = {
    id: string;
};

export function DisclaimerToolbar(props: Props) {
    const toolbarConfig = {
        options: ['bold', 'italic', 'link'],
        buttonSize: 14,
        alignCenter: true,
        className: 'br-3',
    } as const;

    // @ts-expect-error
    return <QuillToolbar id={props.id} config={toolbarConfig} />;
}
